import format from 'date-fns/format'
import Encode from '@/constants/encode'
import Encoding from 'encoding-japanese'

export class CsvUtil {
  static download(csv, name, encode = Encode.SHIFT_JIS) {
    const blobParts = this.makeBlobParts(csv, encode)
    const blob = new Blob(blobParts, { type: 'text/plain' })
    const url = (window.URL || window.webkitURL).createObjectURL(blob)
    const link = document.createElement('a')
    const date = format(new Date(), 'YYYYMMDDHHMMSS')
    link.download = `${name}_${date}.csv`
    link.href = url
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  static makeBlobParts(csv, encode) {
    switch (encode) {
      case Encode.UTF_8: {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        return [bom, csv]
      }
      case Encode.SHIFT_JIS: {
        const unicodeList = []
        for (let i = 0; i < csv.length; i += 1) {
          unicodeList.push(csv.charCodeAt(i))
        }
        const shiftJisArray = Encoding.convert(unicodeList, encode, 'unicode')
        return [new Uint8Array(shiftJisArray)]
      }
    }
    return []
  }
}
